<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-2 col-md-12 col-2 mb-3">
                    <h2>Cancelled Offerings </h2>
                    </div>
                    <div class="col-lg-10 col-md-12 col-10 text-right bid">
                      <div class="input-group d-inline-flex justify-content-end">
                         <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="searchOffer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchOffer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <div class="col-md-4">
                          <multiselect 
                          v-model="selectedEcn" 
                          placeholder="Select Ecn" 
                          :options="ecnList" 
                          :multiple="true" 
                          :limit="4"  ></multiselect>
                        </div>
                        <button @click="cancelOfferings()" type="button" class="btn btn-warning rounded"> Cancel Offering</button>
                        <!-- <button  @click="openAddNewCusipModal()" type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSIP</button> -->
                       

                    </div>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6">
            <div class="row xsOnly">
                <div class="col-xl-12">
                <div class="card scrollbar vh-75" id="scroll">
                    <div class="table-responsive">
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <table class="table align-items-center table-flush table-hover bidtbl">
                        <thead class="thead-light psticky">
                        <tr >
                          <th 
                            scope="col" 
                            class="text-center"
                            ><input v-model="isSelectAll" @change="selectAll()" type="checkbox" class="form-check-input" /></th>
                          <th 
                          scope="col" 
                          class="sort"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                          @click="sort('cusip')">CUSIP/DESC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                          @click="sort('quantity')">QTY</th>
                          <th
                            scope="col"
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                            @click="sort('quantity')">Fill/Rem
                            </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                          @click="sort('price')">PRICE</th>
                          <!-- <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerValidity'  ? 'sort-desc' : '']"  
                          @click="sort('offerValidity')">OFFER <br> VALIDITY</th> -->
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerType'  ? 'sort-desc' : '']"  
                          @click="sort('offerType')">OFFER <br>  TYPE</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                          @click="sort('coupon')">COUPON</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                          @click="sort('cost')">COST</th>
                          <th
                          scope="col"
                          class="sort text-left">TMC<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">TWR<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">KBP<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">MKTX<br>Status/Price
                          </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                          @click="sort('yield')">YIELD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                          @click="sort('yieldSpread')">SPREAD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'balance'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'balance'  ? 'sort-desc' : '']"  
                          @click="sort('balance')">BAL/MIN/INC</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody class="list">
                        <tr v-if="totalRows == 0 && !loading">
                            <td><p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="offer in offerings" :key="offer.id" @click="getOfferDetails(offer)" v-bind:class="{'active-row': offer.isActive}">
                          <td  class="text-center">
                            <input v-model="offer.isSelect" type="checkbox" class="form-check-input" />
                          </td>
                            <td>
                              <span class="cusips"><i class="fas fa-info-circle"></i> {{offer.cusipVal}}</span>
                              <span class="desc">{{offer.cusipDescription}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.quantity}}</span><br>
                          </td>
                           <td class="text-center">
                              <span class="mr-3 d-inline-block">Fill<br><span class="text-danger d-block">{{offer.executedQuantity || 0}}</span></span>
                              <span class="d-inline-block">REM<br><span class="text-success d-block">{{(offer.quantity - offer.executedQuantity) || 0}}</span></span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.price | currency }}   </span><br>
                          </td>
                          <!-- <td class="text-center">
                              <span>{{offer.offerValidity}}</span><br>
                          </td> -->
                          <td class="text-center">
                              <span>{{offer.offerType}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.coupon |  percent(3)}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.cost | currency}}</span><br>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:class="getEcnStatus(offer.tmcStatus).className">{{getEcnStatus(offer.tmcStatus).status}}</span>
                              <span class="text-primary">{{offer.tmcprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:class="getEcnStatus(offer.twdStatus).className">{{getEcnStatus(offer.twdStatus).status}}</span>
                              <span class="text-primary">{{offer.twdprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:class="getEcnStatus(offer.ibpStatus).className">{{getEcnStatus(offer.ibpStatus).status}}</span>
                              <span class="text-primary">{{offer.ibpprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.mktxStatus).message"  v-bind:class="getEcnStatus(offer.mktxStatus).className">{{offer.mktxStatus}}</span>
                              <span class="text-primary">{{offer.mktxPrice | currency}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.yield}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{(offer.price - offer.cost).toFixed(3)}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.balance}} - {{offer.minimum}} - {{offer.incrementVal}}</span>
                          </td>
                            <td class="text-center">
                              <button @click="openCustomerDetailsModal(offer)" class="btn ibtn btn-outline-primary" title="Customers"><i class="far fa-user"></i></button>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getOfferList(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>  
      <customer-details v-if="customerDetailModalOpen" v-bind:offerData="selectedOffer" @close="customerDetailModalOpen = false" />
      <cancelOffer v-if="openCancelModal" v-bind:offerData="selectedOfferIds" @close="closeCancelOfferModal()" />
    </div> 
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import customerDetails from "../ims-offering/ImsOfferingCutomerDetails"
import cancelOffer  from "../ims-offering/imsCancelOfferingModal"
export default {
  name: "imsOfferRecancelComponent",
  components : {
     customerDetails,
     cancelOffer
     
  },
  data() {
    return {
        accessToken: null,
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        selectedCusip : "",
        sortColumn: "latestDate",
        sortOrder: "DESC",
        stateConstants: stateConstants,
        offerings:[],
        customerDetailModalOpen : false,
        selectedOffer : {},
        fromDate : "",
        toDate : "",
        isSelectAll : false,
        openCancelModal : false,
        selectedOfferIds : [],
        ecnList : ["IBP","TMC","TWD","MKTX"],
        selectedEcn :  ["IBP","TMC","TWD","MKTX"],
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,   

    };
  },
  methods: {
    closeCancelOfferModal(){
      this.openCancelModal = false;
      this.getOfferList();    
    },
    cancelOfferings(){
      var isOfferSelected = false;
      var offerids = [];
      this.offerings.forEach(function(offer) {
         if(offer.isSelect){
           isOfferSelected = true;
           offerids.push(offer.id);
         }
      });
      if(!isOfferSelected){
        this.$alert("Please select at least one offer","","error");
        return false;
      }
      if(this.selectedEcn.length == 0){
        this.$alert("Please select at least one Ecn","","error");
        return false;
      }
      var data = []
      offerids.forEach(element => {
          var obj = {};
              obj.offerId = element;
              obj.cancelEcns = this.selectedEcn.map((e) => {
                return { ecn : e ,cancel : true }
              });
              data.push(obj);
      });

      var message = "Are you sure you want to cancel selected offers?";
      this.$confirm(message,"","",{confirmButtonText:"Cancel",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .put(config.baseUrlBidSide + "/offer/cancel-stuck",data,auth)
          .then(() => {
            this.loading = false;
            this.getOfferList();             
          })
          .catch(() => {
              this.loading = false;              
          });
      });

    },
    getEcnStatus(ecnStatus){
      // if(ecnStatus == 'NEW'){
      //   return  { className : "border-success text-success",status : "NEW" }
      // }
      // if(ecnStatus == 'CREATED'){
      //   return  { className : "border-success text-success",status : "CREATED" }
      // }
      // if(ecnStatus == 'SUCCESS'){
      //   return  { className : "border-success text-success",status : "ACCEPTED" }
      // }
      return  { className : "border-success text-success",status : ecnStatus }
    },
    selectAll(){
      var self =  this;
       this.offerings.forEach(function(offer) {
        offer.isSelect = self.isSelectAll;
      });
    },
    searchOffer(){
      this.getOfferList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getOfferList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getOfferList();
    },
    openCustomerDetailsModal(offer){
       this.selectedOffer = offer;
       this.customerDetailModalOpen = true;   
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getOfferDetails(offerSelected){
      this.offerings.forEach(function(offer) {
        offer.isActive = false;
      });
      offerSelected.isActive = true;
    },
    getOfferList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let cognitoSub = this.isTrader && (!this.isAdmin || !this.isEditor) ? authService.getUser().cognitoSub : ""
      this.$http
        .get(
          config.baseUrlBidSide +
            "/offer/listall-cancel-stuck?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cusips="+
            "&accountMappingIds="+
            "&cognitoSub=" +
            cognitoSub,
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(cusip) {
           cusip.selectedEcn = [];
          });
           this.offerings = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },


  },
  mounted() {
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
          this.getOfferList();

        }
      });
  }
};
</script>